<template>
  <div>
    <div class="panal mt-20">
      <div class="panal-header">Search User</div>
      <div class="panal-body">
         <b-form @submit="onSubmit"  v-if="show">

            
            <div class="row">
        
            <div class="col-12 col-md-6 mb-1">
              

<b-form-group id="input-group-1" label="Your Email:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.email"
          placeholder="Enter name"
          required 
          class="form-control su-border"
        ></b-form-input>
 </b-form-group>

            </div>

         

            <div class="col-12 col-md-6 mb-1">
 <b-form-group id="input-group-3" label="NationalID:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="form.nationalid"
          placeholder="Enter NationalID"
          type="number"
          required class="form-control su-border"
        ></b-form-input>
      </b-form-group>


            </div>

            <div class="text-center col-12 mt-2">
              <b-button type="submit" variant="primary" @click="onSubmit">Search</b-button>
            </div>
         
        </div>
         </b-form>
        

<div class="row mt-10" v-if="showForm" >


  <div class=" col-12 col-md-6"><label >Name: </label> <div class="form-control su-border ">{{message["ObjectBasicData"].Name}}</div></div>
  <div class=" col-12 col-md-6"><label >BirthDate: </label><div class="form-control su-border "> {{message["ObjectBasicData"].BirthDate | moment("ll")}}</div></div>
  <div class=" col-12 col-md-6"><label >Address: </label><div class="form-control su-border ">{{message["ObjectBasicData"].Address}}</div></div>
  <div class=" col-12 col-md-6"><label >NationalID: </label><div class="form-control su-border ">{{message["ObjectBasicData"].nationalId}}</div></div>
  <div class=" col-12 col-md-6"><label >Your Phone: </label><div class="form-control su-border ">{{message["ObjectBasicData"].Phones}}</div></div>
  <div class=" col-12 col-md-6"><label >Email address: </label><div class="form-control su-border ">{{message["ObjectBasicData"].Emails}}</div></div>
  <div class=" col-12 col-md-6"><label >Current School: </label><div class="form-control su-border ">{{message["ObjectBasicData"].CurrentSchool}}</div></div>
  <!-- <div class=" col-12 col-md-6"><label >High school certiﬁcate Group: </label><div class="form-control su-border ">{{message[0].CurrentSchool}}</div></div> -->
   <div class=" col-12 col-md-6"><label >High school certiﬁcate: </label><div class="form-control su-border ">{{message["ObjectBasicData"].HighSchoolCertificateID}}</div></div>
 
   <div class=" col-12 col-md-6"><label >EventName: </label>
  <div class="form-control su-border ">{{message["ObjectBasicData"].marketingEventNameAR}}</div></div>
 
    <div class=" col-12 col-md-6"><label >Discount: </label><div class="form-control su-border ">20%</div></div>
    <div class=" col-12 col-md-6"><label >Employee impression: </label><div class="form-control su-border ">{{message["ObjectBasicData"].InterestedFlag}}</div></div>

<div  class="col-12 col-md-12 mb-1 mt-2">
   <label>Faculties interested in</label><br/>

 <!--   -->
       <p   name="Faculties" 
            v-for="fac in UserData.FacultyList" :key="fac.FacultyID"  :value="fac.FacultyID"  class="col-12">
            <b-icon icon="check-circle-fill" variant="primary"></b-icon> {{fac.FacultyName}} 
        </p>
 </div>
 

         </div>
      </div>
    </div>
  </div>
</template>
<script>
import EventService from '../../services/Event/event.services';
 import Vue from 'vue'
// import axios from 'axios'

// Vue.use(axios)  
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);
export default {
  name: "SearchEvent",
  data() {
    return {
         showForm: false,
         message:[],
          nationalid: '',
           email:'',
             UserData : '',
              Discounts: [],         
             Faculties: [], 
form: {
          Discounts: [],         
             Faculties: [], 
        
           nationalid: '',
           email:''
          
        },
        show: true,
     newForm:{
       Name:'',
     }


    };
   
  },
 mounted(){
    // window.onbeforeunload = function() {
    //     this.UserData = JSON.parse(localStorage.removeItem("NationalID"));
    //             // localStorage.clear();
    // },
    EventService.SelectAllCampus().then(Response =>{
              this.campusData = Response.data;
                 this.campusData.forEach((campus,index)=> {
                 EventService.FacultyActiveByBranchAPI(campus.BranchSerial).then(result =>{
                   this.campusData[index].faculties = result.data
                   
                 })
                
            })

            }).finally(()=>{
             
             setTimeout(()=>{
           this.campFac =  this.campusData 
                  this.Loading = false ;
                   console.log("ca,p ",this.campFac)
             },2000)
            })


              EventService.IED_LookupDiscounts_SelectALL().then(Response =>{
               this.Discounts = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
               //console.log('impression => ',this.Discounts)
           }, error => {
              this.empty = true;
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

           
},
   methods: {

   

      onSubmit(event) {
      
          // this.UserData = JSON.parse(localStorage.getItem("NationalID"));
        // alert(JSON.stringify(this.form))

EventService.SelectBasicData(this.form.email , this.form.nationalid ).then(Response =>{
          this.message=Response.data;
          // this.Name=Response.data[0]['Name'];
          this.successful =true;
         
          //this.$alert("Request created succesfully")
          //  alert(JSON.stringify(this.message))
       this.showForm =true;
     
        }, error => {
          this.empty =false
          this.successful =false
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                 if(error.response.status == 404) this.message =''
                     this.showForm =false; 
                     this.$alert("This user not Found")
        
                
               
            });  

 event.preventDefault()
  

       
          // e.preventDefault();
          //      // window.location.reload();



        
    




      },

       SearchEvent(){
   this.$router.push('/SearchResult'); 
      },
   },
      created(){
   this.UserData = JSON.parse(localStorage.getItem("NationalID"));
  
  },
      
};
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  border: 1px solid #d2d2d2;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef !important;
  border-color: #dee2e6;
}
</style>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>